export const DEFAULT_ZOOM = 7;
export const DEFAULT_CENTER = [53.893009, 27.567444];
export const MAX_ZOOM = 17;
